import bee from "./Bee";
export default {
    name: "Footer",
    /*
        var query = {
            email_address: ""
        }
    */
    /* eslint-disable no-unused-vars */
    subscribe_to_news_letter(query,success,fail){
        //first check if this user is already subscribed
        bee.get({
            news_letter_subscriptions:{
                _w: [
                    ["email_address","e", query.email_address]
                ]
            }
        })
        .then(res => {
            var subs = res.news_letter_subscriptions;
            if(subs.length == 0){
                bee.post({
                    news_letter_subscription:{
                        email_address: query.email_address,
                        is_active: 1,
                        date_expired: "1989-01-01",
                        _time_date_expired_timestamp: "1989-01-01"
                    }
                })
                .then(res2 => {
                    if(success){
                        success(res2.news_letter_subscriptions);
                        //nyd
                        //tell the admin that you have a new email subscription
                        //both via sms and email address
                    }
                })
                .catch(errors2 => {
                    if(fail){
                        fail(errors2);
                    }
                });
            }else{
                if(fail){
                    fail(["Email is already subscribed "]);
                }
            }
        })
        .catch(errors => {
            if(fail){
                fail(errors);
            }
        });
    }
} 